<nav class="back-to-top" #backToTop aria-labelledby="back-to-top">
  <a
    href="javascript:void(0);"
    class="back-to-top__link"
    aria-label="Back to top link"
    [core-analytics]="{ action: 'Back to top' }"
    (click)="scrollTop($event)"
  >
    <span id="back-to-top" class="sr-only">Back to top</span>
  </a>
</nav>
